// ── Cart sidebar ──────────────────────────────────────────
function openCart() {
  document.getElementById('cart-sidebar').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  fetchCart();
}
function closeCart() {
  document.getElementById('cart-sidebar').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
}

// ── Add to cart ───────────────────────────────────────────
function addToCartShopify(variantId, btn) {
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
    showToast('✓ Added to cart!');
    fetchCartAndUpdate();
    openCart();
  })
  .catch(function(err) {
    console.error(err);
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
  });
}

// ── Fetch cart ────────────────────────────────────────────
function fetchCart() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      setCartCount(cart.item_count);
      renderCartSidebar(cart);
    });
}

function fetchCartAndUpdate() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      setCartCount(cart.item_count);
      renderCartSidebar(cart);
    });
}

function setCartCount(count) {
  document.querySelectorAll('#cart-count').forEach(function(el) {
    el.textContent = count;
  });
}

// ── Render cart sidebar ───────────────────────────────────
function renderCartSidebar(cart) {
  var body = document.getElementById('cart-body');
  if (!body) return;

  if (!cart.items || cart.items.length === 0) {
    body.innerHTML = '<div class="cart-empty">🛒<br><br>Your cart is empty.</div>';
    return;
  }

  var items = cart.items.map(function(item) {
    var variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div style="font-size:12px;color:var(--text2);margin-bottom:2px">' + item.variant_title + '</div>'
      : '';
    var img = item.image
      ? '<img src="' + item.image + '" alt="' + item.product_title + '" class="cart-item-img" style="object-fit:cover">'
      : '<div class="cart-item-img" style="display:flex;align-items:center;justify-content:center;font-size:28px;background:var(--surface)">🌬️</div>';

    return '<div class="cart-item">'
      + img
      + '<div class="cart-item-info">'
      + '<div class="cart-item-name">' + item.product_title + '</div>'
      + variantLabel
      + '<div class="cart-item-price">' + formatMoney(item.price) + '</div>'
      + '<div class="cart-item-qty-row">'
      + '<button class="qty-sm-btn" onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>'
      + '<span style="font-size:14px;min-width:20px;text-align:center;display:inline-block">' + item.quantity + '</span>'
      + '<button class="qty-sm-btn" onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>'
      + '</div>'
      + '</div>'
      + '</div>';
  }).join('');

  var total = '<div class="cart-sidebar-total">'
    + '<div class="cart-sidebar-total-row"><span style="color:var(--text2)">Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>'
    + '<div class="cart-sidebar-total-row"><span style="color:var(--text2)">Shipping</span><span style="color:#4ade80">Free (UK)</span></div>'
    + '<div class="cart-sidebar-total-row final"><span>Total</span><span style="color:var(--purple2)">' + formatMoney(cart.total_price) + '</span></div>'
    + '</div>'
    + '<a href="/checkout" class="checkout-btn" style="display:block;text-align:center;text-decoration:none;margin-top:16px">Proceed to Checkout →</a>'
    + '<a href="/cart" style="display:block;text-align:center;margin-top:12px;font-size:14px;color:var(--text2);text-decoration:none">View full cart</a>';

  body.innerHTML = items + total;
}

// ── Update item qty (uses item key, not variant id) ───────
function updateCartItem(itemKey, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, quantity: newQty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    setCartCount(cart.item_count);
    renderCartSidebar(cart);
  });
}

// ── Helpers ───────────────────────────────────────────────
function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}

function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2500);
}

// ── Init ──────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  fetchCartAndUpdate();
});
